import { createRoute } from "@tanstack/solid-router";
import { myDayRoute } from "./my-day";

export const myDayTodoRoute = createRoute({
  getParentRoute: () => myDayRoute,
  path: "/todo/$todoId",
  component: MyDayTodoDetailRoutePage,
});

function MyDayTodoDetailRoutePage() {
  return null;
}
